import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input() length:any;
  @Input() pageIndex:any;
  @Input() pageSize:any;
  @Input() pageSizeOptions:any;
  @Input() showFirstLastButtons:any
  @Output() paginationEvent: EventEmitter<PageEvent> = new EventEmitter();

  constructor() { /* TODO document why this constructor is empty */  }

  ngOnInit(): void { 
    // TODO document why this method 'ngOnInit' is empty
  }
  onPaginateChange(event:any) {
    this.paginationEvent.emit(event);
  }
  private _setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

}
